import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React, { useState } from 'react';
import CasePreview from './CasePreview/index.js';
import VoucherCreator from './economy/CaseBilling/VoucherCreator.js';
import PlaceholderLoader from './PlaceholderLoader.js';
import Search from './Search.js';
const AddBillingVoucher = (props) => {
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : null;
    const [caseId, setCaseId] = useState(props.caseId);
    const singleCaseLoader = useCase(caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    return (React.createElement("div", null,
        !props.caseId && (React.createElement(Search, { removeWrapper: true, entity: Entity.Case, onSelect: (res) => {
                console.log(res);
                setCaseId(res.id);
            } })),
        caseId &&
            (singleCase ? (React.createElement(React.Fragment, null,
                !props.caseId && (React.createElement("p", null,
                    React.createElement(CasePreview, { caseId: singleCase.caseId }))),
                React.createElement(VoucherCreator, { caseId: caseId, tenantId: singleCase.tenantId, creditorId: singleCase.creditorId, currency: singleCase.currency, types: (voucherTypes || []).filter((voucherType) => [VoucherCategory.FEE, VoucherCategory.DISBURSEMENT].includes(voucherType.category)), onAdd: props.onAdd }))) : (React.createElement(PlaceholderLoader, null)))));
};
export default AddBillingVoucher;
//# sourceMappingURL=AddBillingVoucher.js.map